import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

import { useSession, type AppSessionUser } from "../../lib/auth-client";

export const Route = createFileRoute("/app/profile")({
  staticData: { title: "Profile" },
  component: ProfileRedirect,
});

function ProfileRedirect() {
  const { data: session, isPending } = useSession();
  const user = session?.user as AppSessionUser | undefined;

  if (isPending) {
    return (
      <div className="flex-1 flex items-center justify-center pt-24">
        <Loader2 className="size-6 text-brand-500 animate-spin" />
      </div>
    );
  }

  if (user?.slug) {
    return <Navigate to="/app/users/$slug" params={{ slug: user.slug }} replace />;
  }

  return <Navigate to="/app" replace />;
}
